import { render, staticRenderFns } from "./OtpVerificationModal.vue?vue&type=template&id=3fd40b9e&scoped=true"
import script from "./OtpVerificationModal.vue?vue&type=script&lang=js"
export * from "./OtpVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./OtpVerificationModal.vue?vue&type=style&index=0&id=3fd40b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd40b9e",
  null
  
)

export default component.exports